import { render, staticRenderFns } from "./MessagePqr.vue?vue&type=template&id=b01d37a4&"
import script from "./MessagePqr.vue?vue&type=script&lang=js&"
export * from "./MessagePqr.vue?vue&type=script&lang=js&"
import style0 from "./MessagePqr.vue?vue&type=style&index=0&id=b01d37a4&prod&lang=css&scope=true&"
import style1 from "./MessagePqr.vue?vue&type=style&index=1&id=b01d37a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports